import { Component, OnDestroy, OnInit } from '@angular/core';
import { MeasurementUnit, RawMaterialTab, RawMaterialWarehouse } from '../../raw-material.model';
import { RawMaterialService } from '../../raw-material.service';
import { forkJoin, Subscription } from 'rxjs';
import { AbstractTabComponent } from '../../../common/abstracts/abstract-tab.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TabItem } from '../../../common/models/common.model';

@Component({
  selector: 'app-raw-material-overview',
  standalone: false,
  templateUrl: './raw-material-overview.component.html',
  styleUrl: './raw-material-overview.component.scss',
})
export class RawMaterialOverviewComponent extends AbstractTabComponent implements OnInit, OnDestroy {
  public override selectedTab: string = RawMaterialTab.CATEGORIES;
  public override tabs: TabItem[] = [
    {
      label: 'Categories',
      value: RawMaterialTab.CATEGORIES,
      icon: 'bi bi-grid-3x3-gap',
      permissionCode: 'ui_raw_material.categories.view',
    },
    {
      label: 'Materials',
      value: RawMaterialTab.MATERIAL,
      icon: 'bi bi-box-seam',
      permissionCode: 'ui_raw_material.materials.view',
    },
    {
      label: 'Suppliers',
      value: RawMaterialTab.SUPPLIERS,
      icon: 'bi bi-truck',
      permissionCode: 'ui_raw_material.suppliers.view',
    },
    {
      label: 'Purchase Orders',
      value: RawMaterialTab.PURCHASED_ORDER,
      icon: 'bi bi-receipt',
      permissionCode: 'ui_raw_material.purchased_orders.view',
    },
    {
      label: 'Entries',
      value: RawMaterialTab.ENTRIES,
      icon: 'bi bi-journal-check',
      permissionCode: 'ui_raw_material.entries.view',
    },
    {
      label: 'Inventory',
      value: RawMaterialTab.INVENTORY,
      icon: 'bi bi-journal-text',
      permissionCode: 'ui_raw_material.inventory.view',
    },
    {
      label: 'Stock Adjustments',
      value: RawMaterialTab.STOCK_ADJUSTMENTS,
      icon: 'bi bi-sliders',
      permissionCode: 'ui_raw_material.stock_adjustments.view',
    },
  ];

  protected recentEntries = [
    {
      materialName: 'Zinc Sulphate',
      warehouseName: 'Warehouse A',
      quantity: 50,
      date: new Date('2025-07-25'),
      type: 'credited',
    },
    {
      materialName: 'Urea',
      warehouseName: 'Warehouse B',
      quantity: 100,
      date: new Date('2025-07-24'),
      type: 'used',
    },
    {
      materialName: 'DAP',
      warehouseName: 'Main Warehouse',
      quantity: 75,
      date: new Date('2025-07-22'),
      type: 'credited',
    },
    {
      materialName: 'MOP',
      warehouseName: 'Warehouse A',
      quantity: 40,
      date: new Date('2025-07-21'),
      type: 'used',
    },
    {
      materialName: 'Calcium Nitrate',
      warehouseName: 'Central Depot',
      quantity: 30,
      date: new Date('2025-07-20'),
      type: 'credited',
    },
  ];
  protected lowStockMaterials = [
    { name: 'Potash', stock: 3 },
    { name: 'Sulphur', stock: 5 },
  ];

  protected wareHouses: RawMaterialWarehouse[] = [];

  constructor(
    private rawMaterialService: RawMaterialService,
    protected override route: ActivatedRoute,
    protected override router: Router
  ) {
    super(route, router);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.getInitialData();
  }

  public override selectTab(tab: string): void {
    super.selectTab(tab);
    // apply your filter logic here
    console.log('Selected Tab:', tab);
  }

  protected units: MeasurementUnit[] = [];

  private rawMaterialSubscription!: Subscription;

  private getInitialData(): void {
    const rawMaterialWarehouses$ = this.rawMaterialService.get_warehouses();
    const rawMaterialUnits$ = this.rawMaterialService.get_units();

    this.rawMaterialSubscription = forkJoin([rawMaterialWarehouses$, rawMaterialUnits$]).subscribe({
      next: ([rawMaterialWarehouses, rawMaterialUnits]: [RawMaterialWarehouse[], MeasurementUnit[]]) => {
        this.wareHouses = rawMaterialWarehouses;
        this.units = rawMaterialUnits;
      },
    });
  }

  ngOnDestroy(): void {
    this.rawMaterialSubscription?.unsubscribe();
  }

  protected readonly RawMaterialTab = RawMaterialTab;
}
